import React, { useState } from "react";
import AppContext from "./AppContext";
import { SIDER_TABS } from "../utils/Constants";

const AppProvider = ({ children }) => {
  const [token, setToken] = useState({});
  const [lastLogInTimestamp, setLastLogInTimestamp] = useState();

  const [isExpanded, setIsExpanded] = useState(true);
  const [selectedSiderTab, setSelectedSiderTab] = useState(SIDER_TABS?.USERS);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedDropdownOption, setSelectedDropdownOption] = useState();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [whichDropdownOpen, setWhichDropdownOpen] = useState([]);


	/**
	 * 
	 * @param {string} tabName
	 * @param {string} dropdownOption 
	 */
  const setActiveSidebarTab = (tabName, dropdownOption = false) => {
    setSelectedSiderTab(tabName);

    if (dropdownOption) {
      setIsDropdownVisible(true);
      setSelectedDropdownOption(dropdownOption);
    }
  };

  const handleWhichDropdownOpen = (tabName) => {
    if (whichDropdownOpen.includes(tabName)) {
      setWhichDropdownOpen((prev) => prev.filter((item) => item !== tabName));
    } else {
      const newDropdownOpen = [...whichDropdownOpen, tabName];
      setWhichDropdownOpen(newDropdownOpen);
    }
  };

  const clearWhichDropdownOpen = () => {
    setWhichDropdownOpen([]);
  };

  return (
    <AppContext.Provider
      value={{
        token,
        setToken,
        lastLogInTimestamp,
        setLastLogInTimestamp,
        isExpanded,
        setIsExpanded,
        selectedSiderTab,
        setSelectedSiderTab,
        selectedDropdownOption,
        setSelectedDropdownOption,
        isDropdownVisible,
        setIsDropdownVisible,
        setActiveSidebarTab,
        isDropdownOpen,
        setIsDropdownOpen,
        whichDropdownOpen,
        setWhichDropdownOpen,
        handleWhichDropdownOpen,
        clearWhichDropdownOpen,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
